import React, { useState } from 'react';
import { FaSun, FaMoon } from 'react-icons/fa';

const MainLayout = ({ children }) => {
  const [darkTheme, setDarkTheme] = useState(true);

  const toggleTheme = () => {
    setDarkTheme(!darkTheme);
  };

  return (
    <div style={{ backgroundColor: darkTheme ? '#222' : '#fff', color: darkTheme ? '#fff' : '#000', minHeight: '100vh' }}>
      <button onClick={toggleTheme} style={{ position: 'absolute', top: '10px', right: '10px', padding: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        {darkTheme ? <FaSun style={{ marginRight: '5px' }} /> : <FaMoon style={{ marginRight: '5px' }} />}
      </button>
      {React.cloneElement(children, { darkTheme })}
    </div>
  );
};

export default MainLayout;
